<template>
  <div class="bg-lightGray mainPad">
    <div class="container">
      <b-alert class="row mt-2" variant="success" style="width:89%;z-index:1;" :show="showDismissibleAlert" dismissible>{{success_msg}}</b-alert>
      <div class="row">
        <div>
          <nav area-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="/recruit">Home</a></li>
              <li class="breadcrumb-item active" aria-current="page">Manage Jobs</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 bg-white shadow mb-4 hide">
          <div class="row">
            <div class="col-lg-4">
              <p class="text-primary lead text-center mb-0"  style="text-transform: capitalize">
                <strong>{{ user.client_name }}</strong>
              </p>
            </div>
            <div class="col-lg-4" v-if="user.account_type">
              <p class="text-primary text-center mb-0 mt-1">Account type: {{ user.account_type }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 mt-8">
          <div class="row">
            <div class="col-md-4 bg-white analysis text-center">
              <span class="icStyle"><i class="fa-solid fa-briefcase"></i></span>
              <h5 class="text-primary">
                <strong>{{ jobs.length }} </strong>
                <span class="text-secondary">Jobs posted</span>
              </h5>
            </div>
            <div class="col-md-4 bg-white analysis text-center d-flex">
              <span class="icStyle"><i class="fa-solid fa-chart-line"></i></span>
              <h5 class="text-success">
                <strong>{{ active_jobs }} </strong>
              </h5>
              <h3 class="text-secondary mb-0 active-jobs">&nbsp;Active jobs</h3>
            </div>
            <div class="col-md-4 bg-white analysis text-center">
              <span class="icStyle"><i class="fa-solid fa-user-graduate"></i></span>
              <h5 style="color: #727cf5">
                <strong>{{ application_count }} </strong>
                <span class="text-secondary mb-0">Applications</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 bradius mb-4 pl-0 pr-0 pb-2">
          <div class="pb-2">
            <div class="col-lg-12">
              <div class="row text-center jobsHead mt-0 pt-0">
                <div class="col-6">
                  <h1 class="text-left text-dark pt mob_h5 h1st1">Manage Jobs </h1>
                </div>
                <div class="col-6">
                  <span class="float-right pt">
                    <a href="/recruit/post-job" target="noopener">
                      <div class="text-right">
                        <button class="btn position-relative"><a href="/recruit/post-private-job" class="text-decoration-none" target="_blank"><h2 class="post-btn">Post private job </h2><span class="new">New</span></a></button>
                        <button class="btn btn-primary" type="submit"><h2 class="post-btn">Post a job </h2></button>
                      </div>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="filter mob_hide bg-white shadow2 boxRadius2 dashboard-filter">
              <form ref="filter-form">
                <div class="row">
                  <div label-for="input-1" class="col-lg-3 pb-0"><v-autocomplete class="inputStyle" v-model="job_param.designation" label="Job title" :items="designations" item-text="text" item-value="id" :searchable="true" clearable outlined></v-autocomplete></div>
                  <div class="col-lg-2 pb-0" label-for="input-2">
                    <v-autocomplete  class="inputStyle" v-model="job_param.city" label="Job location" :items="states" item-text="text" item-value="id" :searchable="true" clearable outlined> 
                      <template slot="item" slot-scope="data">
                        <template v-if = typeof(data.item) != 'object'><v-list-item-content v-text="data.item.text"/></template>
                        <template v-else><v-list-item-content><v-list-item-title v-html="data.item.text"/><v-list-item-sub-title v-html="data.item.group"/></v-list-item-content></template>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div label-for="input-3" class="col-lg-2 pb-0 inputStyle2"><input id="label-date-from mr-8" type="date" v-model="job_param.posted_from" class="form-control"></div>
                  <div label-for="input-3" class="col-lg-2 pb-0 inputStyle2"><input id="label-date-to" type="date" v-model="job_param.posted_to" class="form-control"></div>
                  <div class="col-lg-3 text-right pt-0 pb-0">
                    <button class="mr-4 btn btn-light filterBtn" style="color:#1976d2" @click="submitFilteredJobList" >Apply filter</button>
                    <button class="btn btn-outline-light text-secondary mr-4 filterBtn" @click="resetFilter" >Reset</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="job_list">
              <div v-if="!jobs.length" class="p-4 mb-3 bg-white light-shadow wbx">
                <div class="container text-center mt-5 mb-5" style="color:#afafaf;"><h4 style="font-size:1.75rem !important;"><strong> NO JOBS POSTED YET </strong></h4></div>
              </div>
              <div class="jobdetail bg-white "  v-for="(job, index) in jobs" :key="job.job_id">
                <div class="row">
                  <div class="options">
                    <div class="text-right" style="cursor:pointer" v-on:click="showDropDownList(index)">
                      <div class="dot-icon"><span class="material-icons drop-toggle">more_vert</span></div>
                      <div v-if="dropdown == 'show_drop_list_'+index" class="dropdown dropdown_more">
                        <div class="dropdown-list">
                          <router-link class="text-decoration-none mt-2 text-dark" :to="{ path: 'edit/'+job.job_id+'/'+job.version_name+'/'+user.client_users.client_user_id}"><div class="dropdown-content"><strong>Edit</strong></div></router-link>
                          <div class="dropdown-content"  @click="updateStatus(job.job_id,1)" v-if="job.status == 'Inactive'"><button><strong>Activate</strong></button></div>
                          <div class="dropdown-content" @click="updateStatus(job.job_id,2)"  v-else-if="job.status == 'Active'"><button><strong>Inactivate</strong></button></div>
                          <div class="dropdown-content" @click="copyToClipboard(job)" v-if="job.status == 'Active'"><strong>Copy link</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="mb-0 text-left">
                          <router-link class="text-decoration-none mt-2" v-if="job.type === 1" :to="{name: 'job_description',params: { id: job.job_id, type: job.version_name, user_id: user.client_users.client_user_id}}" target="_blank"><strong>{{ job.job_designation }}&nbsp;</strong></router-link>
                          <router-link class="text-decoration-none mt-2" v-if="job.type === 2" target="_blank" :to="{name:'private_job_description',params: { id: job.job_id, type: job.version_name, user_id: user.client_users.client_user_id}}"><strong>{{ job.job_designation }}&nbsp;</strong></router-link>
                          <b-badge variant="primary" v-if="job.jobfair_id !== null" ><span>Jobfair</span></b-badge>
                          <b-badge variant="success" v-if="job.type == 2" ><span>Private</span></b-badge>
                        </h6>
                      </div>
                    </div>
                    <div class="row"><div class="col-lg-8" v-if="job.role"><p class="mb-0 text-left text-secondary">Job Role: {{job.role}}</p></div></div>
                    <div class="row">
                      <div class="col-lg-12 dates">
                        <span v-if="job.date_of_posting"><small>Posted : {{ job.date_of_posting }}</small></span>
                        <span v-if="job.last_date"><small>Expiry : {{ job.last_date }}</small></span>
                      </div>
                    </div>
                    <div class="row"><div class="col-lg-12" v-if="job.cities"><p class="mb-0 text-left text-secondary" style="word-break: break-all"><i class="fa-solid fa-city ficons"></i>{{ job.cities }}</p></div></div>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="text-right">
                          <p class="mb-0 mt-3 text-secondary"><small style="cursor: pointer" v-on:click.prevent="getQuestionnaire(job)">{{job.hasQuestionare? "Questionnaire": "Add questionnaire"}}</small></p>
                        </div>
                      </div>
                    </div>
                    <hr class="jobHeadline" />
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="row responsWrap">
                          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 pt-0 pb-0">
                            <router-link class="mb-2 text-left text-primary" :to="{path: '/recruit/responses/' + job.job_id}"><span class="responsNotification">{{job.responses}}</span> Responses</router-link>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pt-0 pb-0" v-if="job.status">
                            <p class="mb-2 text-right text-secondary">
                              <span class="status">Job status:</span><span style="color: green" v-if="job.status == 'Active'">{{ job.status }}</span>
                              <span style="color: red" v-else-if="job.status == 'Deleted' || job.status == 'Rejected'">{{ job.status }}</span>
                              <span style="color: orange" v-else>{{job.status}}</span>
                            </p>
                          </div>
                        </div>
                      <div class="mt-4" style="font-size:0.8rem"><a target="_blank" class="text-secondary" href="/recruit/package-pricing">Subscribe for more applications</a></div>                      </div>
                    </div>
                  </div>  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 bg-white shadow mb-4 pb-2 pt-2">
        <AccountUtilization :packages="packages" />
      </div>
      <div class="col-lg-12 bg-white shadow mb-3 mt-3 p-3">
        <div class="row p-3">
          <div class="col-lg-6 mt-2">
            <small>
              <p class="text-secondary">Post a FREE job and view FREE candidate response.</p>
              <p class="text-secondary">Post all your Entry level and Lateral hiring requirement at one place.</p>
            </small>
          </div>
          <div class="col-lg-6">
            <!-- <p class="text-secondary mt-2"></p><h5 class="text-primary">Verify your KYC</h5><p></p>
          <small><p class="text-secondary">Please verify your KYC </p></small>
          <button class="btn btn-primary"> Verify now</button> -->
            <small>
              <p class="text-secondary">Search candidates based on the role, Skills, designation,industry category etc.</p>
              <p class="text-secondary">Do all your candidate communication(Email and SMS) and manage at one place.</p>
            </small>
          </div>
        </div>
      </div>
      </div>
    
      <!-- sendotp modal -->
      <b-modal id="send-otp-modal" hide-footer>
        <template #modal-title > Verify Mobile </template>
        <b-form ref="login-form" @submit ="sendOtp">
          <div class="form-label-group" v-if="!mobileFormHidden">
            <div class="align-items-center d-flex">
              <input id="mobile" v-model="form.mobile" ref="mobile" :disabled="disableEdit" type="text" placeholder="Enter your mobile" :class="{'is-invalid':typeof validate.response.tel != 'undefined' &&!validate.response.tel.val}" class="form-control"  @input="validate.mobileValidation(form.mobile, 'tel')" @keydown.space.prevent/>
              <span class="ml-2"><i class="mdi mdi-pencil-circle-outline" @click="disableEdit = !disableEdit" style="font-size: 1.5rem;color: #888;cursor:pointer"></i></span>
            </div>
              <div class="invalid-feedback" style="display:block;" v-if="(typeof validate.response.tel != 'undefined' && !validate.response.tel.val)" >
                {{ validate.response.tel.msg }}
            </div>
            <div class="invalid-feedback" style="display:block;" v-if="otpError !== '' && otpError !== 'limit_exceeded'">
              {{ otpError }}
            </div> 
            <div class="invalid-feedback" style="display:block;" v-if="otpError == 'limit_exceeded'">
              Too many attempts write to <a href="mailto:recruit@hireclap.com" target="noopener">recruit@hireclap.com</a> to verify your mobile
            </div>
          </div>
          <div class="align-items-center col-9 d-flex form-label-group justify-content-around ml-auto mx-auto" ref="otp-input" v-if="mobileFormHidden">
            <input id="otp_1" v-on:keyup="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.focus()" v-model="form.otp.otp_1" ref="otp_1" type="text" class="form-control col-2 text-center" maxlength="1"/>
            <input id="otp_2" v-on:keyup="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" v-model="form.otp.otp_2" ref="otp_2" type="text" class="form-control col-2 text-center" maxlength="1"/>
            <input id="otp_3" v-on:keyup="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" v-model="form.otp.otp_3" ref="otp_3" type="text" class="form-control col-2 text-center" maxlength="1"/>
            <input id="otp_4" v-on:keyup.delete="$event.target.previousElementSibling.focus()" v-model="form.otp.otp_4" ref="otp_4" type="text" class="form-control col-2 text-center" maxlength="1"/>
          </div>
          <div class="invalid-feedback col-9" style="display: block" v-if="otpError !== '' && mobileFormHidden">{{ otpError }} </div>
          <div class="form-group text-center m-3" v-if="!mobileFormHidden"><b-button type="submit" class="float-right" variant="primary" >Send Otp</b-button></div>
          <div class="form-group text-center m-3" v-if="mobileFormHidden"><b-button @click="verifyOtp" class="float-right" variant="primary">Verify Otp</b-button></div>
        </b-form>
      </b-modal>
    <!-- sendotp modal ends here -->
    <div class="gap50"></div>
    <div class="alert alert-success error-message" id="alert-success" style="display: none;">Copied</div>
  </div>
</template>



<script>
const AccountUtilization = () =>
  import(/* webpackPrefetch: true */ "@/components/AccountUtilization");

export default {
  name: "recruiter_dashboard",
  components: {
    AccountUtilization,
  },
  beforeMount() {
    window.scrollTo(0, 0);
    this.getDesignations();
    this.getEmployer();
    this.getStates();
    this.getClientPackages();
    this.checkForActiveJobfairs();
    if (Object.keys(this.$route.params).length) {
      this.showDismissibleAlert = true;
      this.success_msg = this.$route.params.success;
    }else{
      this.showDismissibleAlert = false;
    }
  },
  data() {
    return {
      jobfairs: [],
      activeJobfair: false,
      validate: new this.$valid(),
      packages: [],
      showDropDown: [],
      showDismissibleAlert: false,
      dropdown: "",
      user: {},
      jobs: [],
      designations: [],
      states: [],
      active_jobs: 0,
      application_count: 0,
      job_param: {
        user_id: null,
        pageNumber: 0,
        designation: null,
        city: null,
        posted_from: null,
        posted_to: null,
      },
      filter: {
        designation: null,
        city: null,
        posted_from: null,
        posted_to: null,
      },
      employer_types: [
        { value: 1, text: "Employer" },
        { value: 2, text: "Consultant" },
        { value: 3, text: "Individual" },
        { value: 4, text: "Institute" },
      ],
        form: {
            mobile: 0,
            otp: {
              otp_1: '',
              otp_2: '',
              otp_3: '',
              otp_4: ''
            }
        },
        disableEdit: true,
        mobileFormHidden: false,
        validateError: false,
        otpError: '',
        success_msg:'',
    };
  },
  methods: {
    openModal: function (type = "") {
      this.open = type == "" ? this.open : type;
      (this.questionModal.open = "exit"), (this.questionModal.open = type);
    },
    getQuestionnaire(job) {
      this.job_id = job.job_id;
      window.open(
        "/recruit/job/questionnaire/" +
          this.job_id +
          "?role=" +
          job.job_role +
          "&&version=" +
          job.version_name +
          "&&user=" +
          this.user.client_users.client_user_id,
        "_blank"
      );
    },
    checkForActiveJobfairs: function () {
      new this.$apiAction()
        .activeJobfairExists()
        .then((res) => {
          if (res.status == true) {
            this.activeJobfair = true;
            this.getJobfairs();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getClientPackages: function () {
      let token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .clientPackages(token)
        .then((res) => {
          if (res.status == true) {
            this.packages = res.packages;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDate(ts) {
      var timestamp = ts * 1000;
      var date = new Date(timestamp);
      return (
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
      );
    },
    updateStatus: function (job_id, status) {
      let token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .updateJobStatus(job_id, status, token)
        .then((res) => {
          if (res.status) this.getJobs();
        });
    },
    getJobfairs: function () {
      // let token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .getJobfairs()
        .then((res) => {
          if (res.status == true) {
            this.jobfairs = res.jobfairs;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDesignations: function () {
      this.designations = [];
      new this.$apiAction().getJobDesignations().then((res) => {
        res.jobdesignations.forEach((e) => {
          this.designations.push({
            value: e.designation_id,
            text: e.designation,
            role_id: e.role_id,
          });
        });
      });
    },
    getStates: async function () {
      await new this.$apiAction().getStates().then(async (data) => {
        this.states.push({ header: "Top Metropolitan Cities" });
        await data.states.forEach(async (element) => {
          await element.cities.forEach((city) => {
            if (city.top_city == 1) {
              this.states.push({
                text: city.city_name,
                id: city.city_id,
                s_id: city.state_id,
                group: "Top Metropolitan Cities",
              });
            }
          });
          this.states.push({ divider: true });
          this.states.push({ header: element.state_name });
          element.cities.forEach((city) => {
            if (city.top_city == 0) {
              this.states.push({
                text: city.city_name,
                id: city.city_id,
                s_id: city.state_id,
                group: element.state_name,
              });
            }
          });
        });
      });
    },
    getEmployer() {
      var emp_token = this.$cookies.get("hire-employer").token;
      if (emp_token !== null) {
        new this.$apiAction()
          .getEmployer(emp_token)
          .then((res) => {
            this.user = res.data;
            this.job_param.user_id = this.user?.client_users.client_user_id;
            if(this.user.client_users.mobile_verified !== 1) {
              this.form.mobile = this.user.client_users.mobile;
              this.openOtpModal();
            }
            this.getEmployerType(this.user.client_type_id);
            this.getJobs();
          })
          .catch((err) => {
            console.log(err);
            this.$cookies.remove("hire-employer");
            this.$router.replace("/recruit").catch(() => {});
          });
      }
    },
    getEmployerType(id) {
      this.employer_types.forEach((type) => {
        if (type.value == id) {
          this.user.account_type = type.text;
        }
      });
    },
    async copyToClipboard(job){
      var emp_token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getJobUrl(job.job_id,emp_token).then((res) => {
        if(res.status === true) {
          (job.type === 1)?navigator.clipboard.writeText(process.env.VUE_APP_URL+'jobs/'+res.data.job_url):navigator.clipboard.writeText(process.env.VUE_APP_URL+'job/'+res.data.job_url);
          document.getElementById('alert-success').style.display = "inline";
          setTimeout(() => {
            this.showDismissibleAlert = false;
          },5000);
        }
      });
    },
    submitFilteredJobList(){
      new this.$apiAction().getJobs(this.job_param).then(res => {
        this.jobs = res.data;
        this.active_jobs=0;
        this.jobs.forEach(job => {
          if(job.status == 'active'){
            this.active_jobs++;
          }
        })
        .catch((err) => {
          console.log(err);
          this.jobs = [];
        });
      });
    },
    resetFilter() {
      this.job_param.designation = null;
      this.job_param.city = null;
      this.job_param.posted_from = null;
      this.job_param.posted_to = null;
      this.getJobs();
    },
    getJobs(){
      new this.$apiAction().getJobs(this.job_param).then(res => {
        this.active_jobs=0
        this.jobs = res.data;
        this.jobs.forEach((job, index) => {
          if(job.status == 'Active'){
            this.active_jobs++;
          }
          if(job.responses>0){
            this.application_count = this.application_count+job.responses;
          }
        this.showDropDown[index] = false;
        })
      })
        .catch((err) => {
          console.log(err);
          this.jobs = [];
      });
    },
    showDropDownList(i) {
      this.dropdown = this.dropdown == "" ? "show_drop_list_" + i : "";
    },
    showDropDownDetails(e) {
      e.preventDefault();
      console.log(this);
    },
    sendOtp(e) {
      e.preventDefault();
      if (
        this.validate.mobileValidation(this.form.mobile, "tel")?.val === false
      ) {
        this.validateError = true;
      }
      if (!this.validateError) {
        let token = this.$cookies.get("hire-employer").token;
        let data = {
          input: {
            mobile: this.form.mobile,
          },
          token: token,
        };
        new this.$apiAction().sendOtp(data).then((res) => {
          if (res.status) {
            this.mobileFormHidden = true;
            this.otpError = "";
          } else {
            this.otpError = res.message;
          }
        });
      }
    },
    verifyOtp() {
      let token = this.$cookies.get("hire-employer").token;
      let otp =
        this.form.otp.otp_1 +
        this.form.otp.otp_2 +
        this.form.otp.otp_3 +
        this.form.otp.otp_4;
      let data = {
        input: {
          mobile: this.form.mobile,
          otp: otp,
        },
        token: token,
      };
      new this.$apiAction().verifyOtp(data).then((res) => {
        if (res.status) {
          this.$bvModal.hide("send-otp-modal");
          this.getEmployer();
          this.showMsgModal('You have successfully verified your mobile number');
          // this.mobileFormHidden = true;
        } else {
          this.otpError = res.message;
        }
      });
      console.log(otp);
    },
    showMsgModal(msg = null) {
      this.boxOne = '';
      this.$bvModal.msgBoxOk(msg, {
          buttonSize: 'sm',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
      });
    },
    openOtpModal() {
      this.mobileFormHidden = false;
      this.validateError = false;
      this.otpError = "";
      this.$bvModal.show("send-otp-modal");
    },
  },
  computed: {
    lang: function () {
      return this.dropdown;
    },
  },
};
</script>

<style>
.new {
  color:#f5b35d;
  font-size: 0.5rem;
  position: absolute;
  top: -5px;
  right: 10px;
  font-weight: bold;
}
.status {
  font-size: 13px;
  color: #a4a8b1;
}
.options {
  position: absolute;
  right: 4px;
  top: 5px;
  z-index: 25;
}

.options .dropdown.dropdown_more {
  min-width: 150px;
  margin: 0px;
  right: 10px;
  text-align: left;
  background: #fff;
  border: none;
  box-shadow: 0px 0px 12px #bfc7d3;
  border-radius: 5px;
  z-index: 5;
}
.options .dropdown.dropdown_more .dropdown-content {
  padding: 10px 10px 10px 15px;
  border-bottom: solid 1px #e9ebef;
}

.dates {
  margin-top: 4px;
}
.dates span {
  display: inline-block;
  margin-right: 30px;
  color: #82868f;
}
.btn-load {
  border: solid 1px #efeeee;
  border-radius: 8px;
  margin: 0 auto;
  width: 200px;
  display: block;
  margin-bottom: 20px;
}
.jobfairBanner h1 {
  font-size: 21px;
  font-weight: bold;
}
.jobfairBanner h2 {
  font-size: 18px;
}
.jobfairBanner {
  margin-bottom: 20px;
  border: solid 1px #d4d7dd;
  border-radius: 5px;
  padding: 20px;
  background: #f4f5f8;
}
.jobfairBanner .btn {
  margin-right: 10px;
  font-size: 13px;
}
.jobfairImg {
  background: #f4f5f8;
  text-align: center;
  border-radius: 5px;
}
.alert-box {
  position: absolute;
  right: -5px;
  background: #ff6969;
  padding: 3px 10px 3px 10px;
  top: -7px;
  font-size: 12px;
  color: #fff;
  border-radius: 0px 7px 0px 7px;
}
.job_list {
  height: auto;

  margin-top: 35px;
  padding: 0px;
}
.icStyle {
  display: block;
  padding: 5px 10px 5px 10px;
  position: absolute;
  left: 10px;
  top: 10px;
  background: #dcdefc;
  color: #727cf5;
  border-radius: 3px;
}
.dropdown_more {
  background-color: #f8f9fa;
  border: 1px solid #efeeee;
  position: absolute;
  margin: 0 0 0 40px;
  width: 50%;
  text-align: center;
}
.dropdown-content:hover {
  background-color: #f0f1f1;
}
#send-otp-modal .form-label-group input:not(:placeholder-shown) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.analysis {
  border-radius: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  max-width: 32.1%;
  box-shadow: 1px 1px 15px #f0f1f6;
  margin-bottom: 10px;
  margin-right: 20px;
}
.analysis span {
  font-size: 15px;
}
.analysis:last-child {
  margin-right: 0px;
}
.analysis h5 {
  font-size: 18px;
  margin-bottom: 0px;
  text-align: left;
  padding-left: 40px;
}
.mlr {
  margin-left: 15px;
  margin-right: 15px;
}
.ficons {
  color: #9fa1a7;
}
.mtb {
  margin-top: 15px;
  margin-bottom: 15px;
}
.bradius {
  border-radius: 5px;
}

.jobfairList {
  background: #fff;
  height: 262px;
  overflow-y: scroll;
}
.jobfairList button {
  display: block;
  margin-bottom: 10px;
}
.btn-jobfair {
  border-bottom: solid 1px #f4f5f9;
  width: 100%;
}
.jobsHead {
  border-bottom: solid 1px #efeeee;
  margin: -30px -45px 0px -45px;
  padding: 15px 19px 0px 19px;

  border-radius: 5px 5px 0px 0px;
}

.jobdetail {
  padding: 0px 20px 20px 20px;
  border: solid 2px #efeeee;
  margin-bottom: 25px;
  margin-right: 0px;
  border-radius: 5px;
  position: relative;
}

.jobdetail .row {
  margin-top: 0px;
}
.jobHeadline {
  margin: 10px -20px 0px -20px;
  border-top: solid 1px #f2eded;
}

@media only screen and (max-width: 1199px) {
  .analysis {
    margin-right: 17px;
  }
}
@media only screen and (max-width: 720px) {
  .responsWrap div {
    display: inline-block;
    width: 50%;
  }
  .jobsHead {
    margin-top: 0px;
    padding-top: 0px;
  }
  .jobdetail {
    margin-bottom: 15px;
  }
  .analysis {
    max-width: 30%;
  }
  .analysis h5 {
    font-size: 13px;
  }
  .analysis span {
    font-size: 11px;
  }
  .jobfairImg {
    display: none;
  }
  .jobfairBanner h1 {
    font-size: 16px;
  }
  .jobfairBanner h2 {
    font-size: 18px;
  }
  .analysis p.text-secondary {
    font-size: 13px;
  }
  .icStyle {
    padding: 5px;
    font-size: 13px;
  }
  .banner_img {
    max-width: 300px;
    margin: 0 auto;
  }
  .mob_h5 {
    font-size: 16px;
  }
  .mob_hide {
    display: none;
  }
  .job_list {
    height: auto;
    margin-top: 0px;
  }
}
@media only screen and (max-width: 576px) {
  .container {
    padding-left: 25px;
    padding-right: 25px;
  }
  .dates span {
    margin-right: 10px;
  }
}

@media only screen and (max-width: 432px) {
  .analysis {
    margin-right: 5px;
    max-width: 32%;
  }

  .analysis h5 {
    padding-left: 25px;
  }
}
@media only screen and (max-width: 360px) {
  .analysis {
    text-align: center;
  }
  .analysis h5 {
    padding-left: 0px;
    text-align: center;
  }
  .analysis h5 strong {
    display: block;
  }
  .analysis .icStyle {
    position: relative;
    display: none;
    left: 0px;
    top: 0px;
    width: 30px;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
